export enum WebSiteState {
    Started = 'Started',
    Stopped = 'Stopped',
}
